import { Link } from 'react-router-dom';

import { FileQuestion, Home, BarChart3, Building2 } from 'lucide-react';

import { NotFoundMeta } from './NotFoundMeta';
import { t } from '@/i18n';

const NAV_LINKS = [
  { to: '/', icon: Home, labelKey: 'not_found.nav.home' },
  { to: '/market/KRW-BTC?exchange=UPBIT', icon: BarChart3, labelKey: 'not_found.nav.market' },
  { to: '/real-estate', icon: Building2, labelKey: 'not_found.nav.real_estate' },
] as const;

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center py-24 px-4">
      {/* TRAD-2464 — 이 화면엔 PageMeta 자체가 없어서, 미등록 경로가 홈 프리렌더 HTML로 서빙되면
          하이드레이션 후에도 홈의 title/og가 그대로 남았다(실측). noindex를 여기서도 선언해
          nginx 폴백 셸(app-shell.html)과 2단으로 막는다. */}
      <NotFoundMeta />
      <FileQuestion size={64} className="text-muted-foreground/40 mb-6" strokeWidth={1.5} />
      <h1 className="text-5xl font-bold text-muted-foreground mb-3">404</h1>
      <p className="text-lg text-muted-foreground mb-8">{t('not_found.message')}</p>
      <div className="flex gap-3">
        {NAV_LINKS.map(({ to, icon: Icon, labelKey }) => (
          <Link
            key={to}
            to={to}
            className="flex items-center gap-2 px-5 py-2.5 bg-secondary text-foreground rounded-full text-sm font-medium hover:bg-secondary/80 transition-colors"
          >
            <Icon size={16} />
            {t(labelKey)}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default NotFound;
